// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-type .ant-modal-footer {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
